module.exports = __webpack_public_path__ + "img/icon-eula.4558c994.webp";